<template>
  <div class="modal fade bautagemodal" id="bautagemodal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <form v-on:submit.prevent="createNewConstructionReport">
        <div class="modal-content">
          <div class="modal-header p-3 bg-light">
            <h4 class="modal-title"><strong>Bautagesbericht erstellen</strong></h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
          </div>
          <div class="modal-body pb-2">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-2nd mb-4">
                <div class="row btns-cr">
                  <div class="col-md-6 mb-3 font14">
                    <div @click="newReport.reporttype = 'D'" class="p-1 rounded border text-center ml-2" :class="{'active': newReport.reporttype === 'D'}">
                      <span class="btn-font-cr">Tagesbericht</span>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3 pl-0">
                    <div @click="newReport.reporttype = 'W'" class="p-1 rounded border text-center mr-3" :class="{'active': newReport.reporttype === 'W'}">
                      <span class="btn-font-cr">Wochenbericht</span>
                    </div>
                  </div>
                </div>

                <p class="mb-2">
                  <strong> Letzter
                    <span v-if="newReport.reporttype === 'W'">Wochenbericht </span>
                    <span v-else>Tagesbericht </span> :
                  </strong>
                </p>
                <div class="row">
                  <label class="form-label col-6">Nummer :</label>
                  <div class="col-6">
                    <span v-if="newReport.reporttype === 'W'">{{nextReport.meta.w_maxrunid}}</span>
                    <span v-else>{{nextReport.meta.maxrunid}}</span>
                  </div>
                </div>

                <div class="row">
<!--                  TODO: Revision for week reports-->
                  <label class="form-label col-6">Revision :</label>
                  <div class="col-6"><span v-if="lastReport">{{lastReport.revision}}</span></div>
                </div>

                <div class="row">
                  <label class="form-label col-6">
                    <span v-if="newReport.reporttype === 'W'">WB</span>
                    <span v-else>TB </span> -Datum :</label>
                  <div class="col-6"><span v-if="lastReport">{{setDate(lastReport.crdate)}}</span></div>
                </div>
                <hr>
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12 col-2nd mb-4">
                <div class="row">
                  <label class="form-label col-6 pr-0">Neue
                    <span v-if="newReport.reporttype === 'W'">Wochenbericht</span>
                    <span v-else>Tagesbericht</span>-Nummer :
                  </label>
                  <div class="col-6 ">
                    <input class="input--style-2 pl-1" type="text" v-model="newReport.runid" />
                  </div>
                </div>

                <div class="row" v-show="newReport.reporttype === 'D'">
                  <label  class="form-label col-6 pt-3" for="dates">TB-Datum : </label>
                  <div class="col-6 pt-3">
                    <div  class="d-flex date date-pick mr-2">
                      <span class="input-group-addon font1rem text-dark  mr-1"><i class="fa fa-calendar"></i></span>
                      <input id="dates" :value="setDate(newReport.crdate)" class="form-control font1rem input-style " data-date-format="dd.mm.yyyy" required>
                    </div>
                  </div>
                </div>

                <div v-show="newReport.reporttype === 'W'" class="row">
                  <div class="col-md-12 mb-3">
                    <div class="row">
                      <label class="form-label pt-1 col-6 mb-3 font-weight-boldx  pt-3"> KW : </label>
                      <div class="col-6  pt-3">
                        <select v-model="kwSelect" class="form-control-sm form-control w-100" style="height: 28px;padding: 0; border-left:0; border-top:0; border-right:0; border-radius: 0;">
                          <option :value="kw" v-for="(kw,index) in kwSelection" :key="index" :selected="kw == kwSelected">KW: {{kw.week}} ({{kw.dropdownstring}})</option>
                        </select>
                      </div>
                    </div>
<!--                    <div class="row mt-2">-->
<!--                      <label class="form-label col-6 mb-3 font-weight-boldx"> Datum von : </label>-->
<!--                      <div class="col-6 pl-0">-->
<!--                        <div data-date-format="dd.mm.yyyy" class="d-flex input-group input-group-sm date datepicker_small_input w-100">-->
<!--                          <div class="input-group-prepend">-->
<!--                            <input :value="setDate(selected_kw.weekstartdate)"  type="text" data-date-format="dd.mm.yyyy" readonly="readonly" class="form-control date-input border-right-0" style="border-top-right-radius: 0; border-bottom-right-radius: 0">-->
<!--                            <span class="input-group-text border-left-0"><i class="fa-regular  fa-calendar-minus"></i></span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="row mt-2">-->
<!--                      <label class="form-label col-6 mb-3 font-weight-boldx"> Datum bis : </label>-->
<!--                      <div class="col-6 pl-0">-->
<!--                        <div data-date-format="dd.mm.yyyy" class="d-flex input-group input-group-sm date datepicker_small_input w-100">-->
<!--                          <div class="input-group-prepend">-->
<!--                            <input :value="setDate(selected_kw.weekenddate)" type="text" data-date-format="dd.mm.yyyy" readonly="readonly" class="form-control date-input border-right-0" style="border-top-right-radius: 0; border-bottom-right-radius: 0">-->
<!--                            <span class="input-group-text border-left-0"><i class="fa-regular  fa-calendar-minus"></i></span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
                  </div>
                </div>




              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-3rd" v-show="newReport.reporttype === 'D'">
                <div class="form-group mt-1">
                  <label class="form-label">Inhalt aus Bericht übernehmen</label>
                  <select class="cus-select1 mt-1 active" size="5" v-model="selected_report_id" style="overflow: auto !important;">
                    <option value="">Nichts übernehmen</option>
                    <option v-for="rp in nextReport.constructionreports.dayReports" :value="rp.constructionreportid">
                      Tagesbericht - Nr. {{ rp.runid }} <template v-if="rp.revision > 0">(Rev. {{rp.revision}})</template> {{setDate(rp.crdate)}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-3rd" v-show="newReport.reporttype === 'W'">
                <div class="form-group mt-1">
                  <label class="form-label">Inhalt aus Bericht übernehmen</label>
                  <select class="cus-select1 mt-1 active" size="5" v-model="selected_week_report_id">
                    <option value="">Nichts übernehmen</option>
                    <option v-for="rp in nextReport.constructionreports.weekReports" :value="rp.constructionreportid">
                      Wochenbericht - Nr. {{ rp.runid }} <template v-if="rp.revision > 0">(Rev. {{rp.revision}})</template> {{setDate(rp.reportstartdate)}} - {{setDate(rp.crdate)}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer pb-2 pt-2">
            <div class="dokubtns"> <span class="btninner">
              <button type="button" class="btn btn-red" data-dismiss="modal">Abbrechen</button>
              <button type="submit"  class="btn btn-blue">
                Neu erstellen
              </button>
            </span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {formatAsInputDate, formatDate} from '../../common.js'
import axios from 'axios'

export default {
  data(){
    return {
      selected_report_id: '',
      selected_week_report_id: '',
      selected_kw: {}
    }
  },
  mounted () {
    this.setDatePicker()
    console.log('Mounted')
  },
  updated () {
    this.setDatePicker()
  },
  computed: {
    ...mapState({
      lastReport: state => state.constructionDiary.lastReport,
      allReports: state => state.constructionDiary.allReports,
      newReport: state => state.constructionDiary.newReport,
      kwSelection: state => state.constructionDiary.kwSelection,
      reportparams: state => state.constructionDiary.reportparams,
      kwSelected: state => state.constructionDiary.kwSelected,
      nextReport: state => state.constructionDiary.nextReport,
      user: state => state.projects.user
    }),
    kwSelect: {
      get(){
        return this.kwSelected
      },
      set(newValue) {
        this.$store.commit('setKwSelected',newValue || {})
        return newValue
      }
    }
  },
  methods: {
    format_date(value){
      if (value) {
        return moment(String(value)).format('DD.MM.YYYY')
      }
    },
    setDatePicker () {
      let _this = this
      $('#dates').datepicker({
        autoclose: true,
        todayHighlight: true,
      }).on('changeDate', function(ev){
        _this.newReport.crdate = formatAsInputDate(ev.target.value);
      });
    },

    setDate(date){
      return formatDate(date)
    },


    async createNewConstructionReport(){
      $('#bautagemodal').modal("toggle");
      let report = this.newReport;
      let selectedtemplate;
      if(this.newReport.reporttype == "D") {
        selectedtemplate = this.selected_report_id
      } else {
        selectedtemplate = this.selected_week_report_id
      }


      report.projectid = this.$route.params.id;
      report.pduserid =  this.user.pduserid || localStorage.user_id;
      report.creator =   `${this.user.firstname} ${this.user.lastname}`;
      report.reportparams = this.reportparams

      this.$store.commit('loading',true);
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "createConstructionReport",
          "parameters": [report,selectedtemplate],
          // "parameters": [report,this.selected_report_id],
          "serviceName": "ProjectdocuService"
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(response=> {
        if (response.statusText === "OK" || response.statusText === "OK"){
          this.$toast.success("Bautagebuch erstellt")
          this.$router.push({name: 'editConstructionReport',params:{id: report.projectid.toString(),reportId: response.data.constructionreportid }})
        }
        this.$store.commit('loading',false);
      }).catch(error=> {
        this.$store.commit('loading',false);
      })
    }
  },
  watch: {
    '$store.state.constructionDiary.newReport.reporttype': function(val) {
      console.log('Berichtstyp change', val)
      if(val == 'W') {
        // this.selected_report_id = ''
        console.log('Whatch IS W')
        this.newReport.runid = parseInt(this.nextReport.meta.w_maxrunid) + 1
        // this.newReport.reportstartdate = this.selected_kw.weekstartdate
        // this.newReport.crdate = this.selected_kw.weekenddate
        this.newReport.reportstartdate = this.kwSelected.weekstartdate
        this.newReport.crdate = this.kwSelected.weekenddate
      } else {
        // this.selected_report_id = ''
        this.newReport.crdate = moment().format('YYYY-MM-DD');
        this.newReport.runid = parseInt(this.nextReport.meta.maxrunid) + 1
        console.log('Whatch IS D', this.newReport.runid)
      }
    },
    kwSelection: function (val){
      if (val || val.length){
        this.selected_kw = val[0]
      }
    },
    kwSelected: function(val) {
      console.log('KW Change', this.kwSelected, val)
      if(this.newReport.reporttype == 'D') {
        this.newReport.crdate = moment().format('YYYY-MM-DD');
      } else {
        this.newReport.reportstartdate = this.kwSelected.weekstartdate
        this.newReport.crdate = this.kwSelected.weekenddate
      }
    },
    selected_week_report_id: function(val) {
      // this.selected_report_id = val
    }
    // selected_kw: function(val) {
    //   console.log('KW Change', this.selected_kw, val)
    //   this.newReport.reportstartdate = this.selected_kw.weekstartdate
    //   this.newReport.crdate = this.selected_kw.weekenddate
    // }
  }
}
</script>
<style scoped>
select.cus-select1,select.cus-select1 option{
  font-size: 1rem;
}
.btn-font-cr{
  font-size: .98rem;
  font-weight: 500;
}
.btns-cr .col-md-6 div.active{
  background: #3399FF;
  color: white !important;
}
.btns-cr .col-md-6 div{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/CreateReportModal.vue